import { createAction } from "@reduxjs/toolkit";
import {
  FETCH_ACCOUNT_REQUEST,
  FETCHING_ACCOUNT_FAILED,
  FETCHING_ACCOUNT_SUCCEDDED,
  UPDATE_ACCOUNT_REQUEST,
  UPDATING_ACCOUNT_SUCCEDDED,
  UPDATING_ACCOUNT_FAILED,
  UPDATING_PRIVACY_POLICY_CONTROL,
  UPDATING_PRIVACY_POLICY_CONTROL_SUCCEEDED,
  UPDATING_PRIVACY_POLICY_CONTROL_FAILED
} from "./actionTypes";

import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import buildUrl from "build-url-ts";
import { Account, UpdateAccountRequest } from "../../types/accounts";

import _ from "lodash";
import Cookies from "js-cookie";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;


/**
 * Fetch account details
*/
export const fetchAccount = createAction<void>(FETCH_ACCOUNT_REQUEST);
const fetchingAccountSucceeded = createAction<Account>(FETCHING_ACCOUNT_SUCCEDDED);
const fetchingAccountFailed = createAction<any>(FETCHING_ACCOUNT_FAILED);

const fetchAccountSaga = function* (): any {
  const url = buildUrl(apiUrl, {
    path: `/api/2.0/accounts`
  });

  const fetchAccountApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => {
      const data = response.data;

      let shouldUpgradeToNewExperience = _.get(
        data,
        "shouldUpgradeToNewExperience",
        false
      );

      if (
        shouldUpgradeToNewExperience &&
        Cookies.get("_paperflite_ui_experience") !== "v2"
      ) {
        // set the cookies for the new experience
        Cookies.remove('_paperflite_ui_experience');
        Cookies.set("_paperflite_ui_experience", "v2", {path: "/", secure: true, sameSite: "none"});
        if (Cookies.get("_paperflite_ui_experience") == "v2") {
          window.location.reload();
        }
      } else if (
        !shouldUpgradeToNewExperience &&
        Cookies.get("_paperflite_ui_experience") === "v2"
      ) {
        Cookies.remove('_paperflite_ui_experience', {path: "/"});
      }
      return data
    });
  };

  try {
    const response = yield call(fetchAccountApi);
    yield put(fetchingAccountSucceeded(response));
  } catch (error) {
    yield put(fetchingAccountFailed(error));
  }
};



//todo: declare a type for request and error
export const updateAccount = createAction<UpdateAccountRequest>(UPDATE_ACCOUNT_REQUEST);
export const updatingAccountSucceeded = createAction<Account>(UPDATING_ACCOUNT_SUCCEDDED);
export const updatingAccountFailed = createAction<any>(UPDATING_ACCOUNT_FAILED);  

const updateAccountSaga = function* (action: any): any {
  const url = buildUrl(apiUrl, {
    path:"/api/2.0/accounts"
  });
  const updateAccountApi = async (data: UpdateAccountRequest) => {
    return axios({
      method: 'PUT',
      url: url,
      data: data
    }).then((response) => response.data);
  }
  try {
    const response = yield call(updateAccountApi, action.payload);
    yield put(updatingAccountSucceeded(response));
  }catch(error) {
    yield put(updatingAccountFailed(error));
  }
}

//update privacy policy control
export const updatePrivacyPolicyControl = createAction<{privacyPolicyData: {}, consentRequired: string}>(UPDATING_PRIVACY_POLICY_CONTROL);
const updatingPrivacyPolicyControlSucceeded = createAction<void>(UPDATING_PRIVACY_POLICY_CONTROL_SUCCEEDED);
const updatingPrivacyPolicyControlFailed = createAction<any>(UPDATING_PRIVACY_POLICY_CONTROL_FAILED);

const updatePrivacyPolicyControlSaga = function* (action: any): any {
  const url = buildUrl(apiUrl, {
    path:"/api/2.0/accounts/privacy-policy-control"
  });
  const updatePrivacyPolicyControlApi = async (data: any) => {
    const request = action.payload;

    return axios({
      method: 'PUT',
      url: url,
      data: request.privacyPolicyData,
      params: {consentRequired: request.consentRequired}
    }).then((response) => response.data);
  }
  try {
    const response = yield call(updatePrivacyPolicyControlApi, action.payload);
    yield put(updatingPrivacyPolicyControlSucceeded(response));
  }catch(error) {
    yield put(updatingPrivacyPolicyControlFailed(error));
  }
}

export default function* accountsSaga() {
  yield takeEvery(FETCH_ACCOUNT_REQUEST, fetchAccountSaga);
  yield takeEvery(UPDATE_ACCOUNT_REQUEST, updateAccountSaga);
  yield takeEvery(UPDATING_PRIVACY_POLICY_CONTROL, updatePrivacyPolicyControlSaga);
}